<!--
 * @Date: 2024-03-22 14:33:56

-->
<template>
  <bk-view :class="['points-item']">
    <bk-view class="points-item-header" :class="pointItem.points > 0 ? 'earning' : 'redemption'">
      <bk-lang :code="pointItem.points > 0 ? 'points_detail_title_earning': 'points_detail_title_redemption'"></bk-lang>
      <bk-lang :code="pointsTypeCode"></bk-lang>
      <bk-view>{{ pointItem.points > 0 ? '+' : ''}}{{ pointItem.points }}</bk-view>
    </bk-view>
    <bk-view v-if="pointItem.pointsType==='Sales'"> <bk-lang code="clients_loyaltyPointsDetail_ref"></bk-lang> {{ pointItem.billNo }}</bk-view>
    <bk-view><bk-lang code="clients_loyaltyPointsDetail_operator"></bk-lang> {{ pointItem.createUser }}</bk-view>
    <bk-view><bk-lang code="clients_loyaltyPointsDetail_time"></bk-lang><bk-date :date="pointItem.accessDate" :curShop="pointItem"></bk-date></bk-view>
    <bk-view class="overflowText"><bk-lang code="clients_loyaltyPointsDetail_store"></bk-lang>{{ pointItem.compName }}</bk-view>
    <bk-view v-if="pointItem.pointsType==='Adjustment'">
      <bk-lang code="clients_loyaltyPointsDetail_reason"></bk-lang>
      <bk-view>{{ pointItem.remark || '-' }}</bk-view>
    </bk-view>
  </bk-view>
</template>
  
<script>
  
	export default {
		name: 'PointsItem',
		props: {
			lastFlag: Boolean,
			pointItem: {
				type: Object,
				default: () => {
					return {}; 
				}
			}
		},
		computed: {
			pointsTypeCode () {
				let pointsType = this.pointItem.pointsType?.replace(/\s*/g, '').toLowerCase();

				return {
					sales:'points_detail_type_sales',
					'newcustomer':'points_detail_type_newCustomer',
					adjustment:'points_detail_type_adjustment',
					import:'points_detail_type_import',
					referral:'points_detail_type_referral',
				}[pointsType];
			}
		}
	};
</script>
  
<style lang='less' scoped>
  @earn-color: #26E293;
  @redemption-color: #FF7D20;
  .points-item {
    margin: 16px 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #EFE9E5;

    &-header {
      justify-content: space-between;
      margin-bottom: 10px !important;
      font-weight: 600;
      > .bk-view,
      > .bk-lang {
        color: #333;
        font-size: 14px;
      }

      &.earning {
        .bk-lang,
        .bk-view {
          &:not(:nth-child(2)) {
            color: @earn-color !important;
          }
        }
      }

      &.redemption {
        .bk-lang,
        .bk-view {
          &:not(:nth-child(2)) {
            color: @redemption-color !important;
          }
        }
      }
    }

    > .bk-view {
      display: flex;
      margin-bottom: 4px;
      font-family: Plus Jakarta Sans, Plus Jakarta Sans;
      color: #666666;
      font-size: 12px;

      &.overflowText {
        display: block;
      }
    }
  }
</style>